/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ubuntu_Show_AppsInputs */

const en_ubuntu_show_apps = /** @type {(inputs: Ubuntu_Show_AppsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Applications`)
};

const ar_ubuntu_show_apps = /** @type {(inputs: Ubuntu_Show_AppsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض التطبيقات`)
};

const bn_ubuntu_show_apps = /** @type {(inputs: Ubuntu_Show_AppsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অ্যাপ দেখান`)
};

const de_ubuntu_show_apps = /** @type {(inputs: Ubuntu_Show_AppsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anwendungen anzeigen`)
};

const es_ubuntu_show_apps = /** @type {(inputs: Ubuntu_Show_AppsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar Aplicaciones`)
};

const fr_ubuntu_show_apps = /** @type {(inputs: Ubuntu_Show_AppsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher les candidatures`)
};

const pt_ubuntu_show_apps = /** @type {(inputs: Ubuntu_Show_AppsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar aplicativos`)
};

const zh_ubuntu_show_apps = /** @type {(inputs: Ubuntu_Show_AppsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示应用程序`)
};

const tr_ubuntu_show_apps = /** @type {(inputs: Ubuntu_Show_AppsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uygulamaları Göster`)
};

const ru_ubuntu_show_apps = /** @type {(inputs: Ubuntu_Show_AppsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показать приложения`)
};

const pl_ubuntu_show_apps = /** @type {(inputs: Ubuntu_Show_AppsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokaż aplikacje`)
};

/**
* | output |
* | --- |
* | "Show Applications" |
*
* @param {Ubuntu_Show_AppsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const ubuntu_show_apps = /** @type {((inputs?: Ubuntu_Show_AppsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ubuntu_Show_AppsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ubuntu_show_apps(inputs)
	if (locale === "bn") return bn_ubuntu_show_apps(inputs)
	if (locale === "de") return de_ubuntu_show_apps(inputs)
	if (locale === "es") return es_ubuntu_show_apps(inputs)
	if (locale === "fr") return fr_ubuntu_show_apps(inputs)
	if (locale === "pt") return pt_ubuntu_show_apps(inputs)
	if (locale === "zh") return zh_ubuntu_show_apps(inputs)
	if (locale === "tr") return tr_ubuntu_show_apps(inputs)
	if (locale === "ru") return ru_ubuntu_show_apps(inputs)
	if (locale === "pl") return pl_ubuntu_show_apps(inputs)
	return en_ubuntu_show_apps(inputs)
});